module.exports = __webpack_public_path__ + "img/designguide_2.6b88ff2.webp";